/* PARROTTY — show the added product's name in the "Added to cart"
   notification header. Hooks into Dawn's existing <cart-notification>
   web component (assets/cart-notification.js) without editing that
   core file: patches CartNotification.prototype.renderContents after
   the class is defined, injecting a name element into the notification
   heading once and updating its text on every add-to-cart.
   ========================================================================== */
(function () {
  function patch() {
    if (!window.customElements || !customElements.get('cart-notification')) {
      requestAnimationFrame(patch);
      return;
    }

    var CartNotificationEl = customElements.get('cart-notification');
    var proto = CartNotificationEl.prototype;

    if (!proto || proto.__nuraItemNamePatched || typeof proto.renderContents !== 'function') {
      return;
    }

    var originalRenderContents = proto.renderContents;

    proto.renderContents = function (parsedState) {
      originalRenderContents.call(this, parsedState);

      var heading = this.notification && this.notification.querySelector('.cart-notification__heading');
      if (!heading) return;

      var nameEl = heading.querySelector('#cart-notification-item-name');
      if (!nameEl) {
        nameEl = document.createElement('span');
        nameEl.id = 'cart-notification-item-name';
        nameEl.className = 'cart-notification__item-name';
        heading.appendChild(nameEl);
      }

      var productNameEl = document.querySelector(
        '#cart-notification-product .cart-notification-product__name'
      );
      var productName = productNameEl ? productNameEl.textContent.trim() : '';
      nameEl.textContent = productName ? '\u2014 ' + productName : '';
        var atcBtn = window.__nuraLastAtcButton;
          if (atcBtn) {
            atcBtn.classList.add('nura-atb-success');
            setTimeout(function () {
              atcBtn.classList.remove('nura-atb-success');
            }, 900);
          }
        };  

    proto.__nuraItemNamePatched = true;
  }

  patch();
  // ---- Track which Add to Cart button was just clicked, so we can
  // flash a success state on it once Dawn confirms the item was added ----
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[data-type="add-to-cart-form"]')) {
        var btn = form.querySelector('.nura-product-card__atb[type="submit"]');
        if (btn) window.__nuraLastAtcButton = btn;
      }
    },
    true
  );
})();